module.exports = __webpack_public_path__ + "static/media/icalendar-sync.5b609180.svg";